import hooks from '../../hooks';
import contentEditable from '../../content-editable';

const documentCutHandler = (event) => {
  contentEditable.handlers.checkpointDelayHandler(event);
  hooks.handlers.onTextCut(event);
};

export default documentCutHandler;
